import { Button, Collapse, Pagination, Spin, Table, Tag, Empty } from "antd";

const OrderHistorySection = ({
  todaysOrders,
  orderColumns,
  today_page,
  today_total,
  today_per_page,
  change_today_pagination,
  handleViewClick,
  setActiveTab,
  activeTab,
  spinnerLoading,
  newAntIcon,
}) => {
  const isTodayDeliveryTab = activeTab === "todays_delivery";
  const isCompletedTab = activeTab === "completed";
  const isSalesTab = activeTab === "todays_sales";

  return (
    <div>
      {spinnerLoading ? (
        <div>
          <Spin indicator={newAntIcon} />
        </div>
      ) : (
        <>
          {todaysOrders.length === 0 ? (
            <div className="text-center py-8">
              <Empty
                description="No orders for today"
                image={Empty.PRESENTED_IMAGE_SIMPLE}
              />
            </div>
          ) : (
            <div>
              <div className="desktop show-all">
                <Table
                  scroll={{ x: true }}
                  pagination={false}
                  bordered
                  columns={orderColumns}
                  dataSource={todaysOrders}
                />
                <div style={{ marginTop: "2%" }}></div>
                <Pagination
                  showSizeChanger
                  current={today_page}
                  total={today_total}
                  showTotal={(total, range) =>
                    `${range[0]} - ${range[1]} of ${total} transaction`
                  }
                  defaultPageSize={today_per_page}
                  onChange={change_today_pagination}
                />
              </div>
              <div className="mobile topup-data">
                <Collapse defaultActiveKey={[0]}>
                  {todaysOrders.map((order, index) => (
                    <Collapse.Panel
                      showArrow={false}
                      key={index}
                      header={
                        <p style={{ display: "inline" }}>
                          Ordered on{" "}
                          {new Date(order.createdAt).toLocaleString()}
                        </p>
                      }
                    >
                      <div>
                        <ul className="mobile-list-flex">
                          <li>
                            <span>Date:</span>
                            <span>
                              {new Date(order.createdAt).toLocaleString()}
                            </span>
                          </li>
                          <li>
                            <span>Order Code:</span>
                            <span>#{order.orderCode}</span>
                          </li>
                          <li>
                            <span>Items:</span>
                            <span>
                              {Array.isArray(order.orderItems)
                                ? order.orderItems
                                    .map((item) => item.quantity || 0)
                                    .reduce((a, b) => a + b, 0)
                                : 0}
                            </span>
                          </li>
                          <li>
                            <span>Delivery Type:</span>
                            <span>{order.deliveryType}</span>
                          </li>
                          <div className="mt-3">
                            <Button
                              type="link"
                              onClick={() => handleViewClick(order)}
                            >
                              View Details
                            </Button>
                          </div>
                        </ul>
                      </div>
                    </Collapse.Panel>
                  ))}
                </Collapse>
                <div style={{ marginTop: "1%" }}>
                  <Pagination
                    showSizeChanger
                    current={today_page}
                    total={today_total}
                    showTotal={(total, range) =>
                      `${range[0]} - ${range[1]} of ${total} transaction`
                    }
                    defaultPageSize={today_per_page}
                    onChange={change_today_pagination}
                  />
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default OrderHistorySection;
